import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';

export default function Subscribe() {
    const emailMap: any = {
        au: {
            type: 'klaviyo',
            list_id: 'V57qTr',
            source: 'EcoFlow Whole Home from',
            consent_form_id: 'XqD6GX',
            popupBtnLink: 'https://www.facebook.com/groups/542727324566593',
        },
    };
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const emailConf = emailMap[locale] || emailMap.us;
    const [popupVisible, setPopupVisible] = useState(false);
    return (
        <div className={`subscribe ${css.subscribe}`}>
            <p className="title">{t('sec2_title')}</p>
            <p className="desc">{t('sec2_desc')}</p>
            <div className="control">
                {emailConf?.type === 'klaviyo' && (
                    <Klaviyo
                        extra_properties={{
                            custom_source: emailConf.source,
                            $source: emailConf.source,
                            $method_type: 'Klaviyo Form',
                            $consent_version: 'Embed default text',
                            $consent_form_id: emailConf.consent_form_id,
                        }}
                        successCallback={() => {
                            setPopupVisible(true);
                            try {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_submit',
                                    button_name: t('sec2_sign'),
                                    status: 'success',
                                    tag: 'None',
                                });
                                window?.fbq && window?.fbq('track', 'Lead');
                            } catch (e) {
                                console.error(e);
                            }
                        }}
                        errorCallback={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('sec2_sign'),
                                status: 'fail',
                                tag: 'None',
                            });
                        }}
                    >
                        <KlaviyoView list_id={emailConf.list_id} submitText={t('sec2_sign')} placeholder={t('sec2_placeholder')} />
                    </Klaviyo>
                )}
                {emailConf.type === 'mailchimp' && (
                    <>
                        <Mailchimp
                            successCallback={() => {
                                setPopupVisible(true);
                                try {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'activity_submit',
                                        button_name: t('sec2_sign'),
                                        status: 'success',
                                        tag: 'None',
                                    });
                                    window?.fbq('track', 'Lead');
                                } catch (e) {
                                    console.error(e);
                                }
                            }}
                            errorCallback={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'activity_submit',
                                    button_name: t('sec2_sign'),
                                    status: 'fail',
                                    tag: 'None',
                                });
                            }}
                        >
                            <MailchimpView
                                action={emailConf.action}
                                extraFields={emailConf.extraFields}
                                submitText={t('sec2_sign')}
                                placeholder={t('sec2_placeholder')}
                            />
                        </Mailchimp>
                    </>
                )}
                {/* {showPolicyCheck && <PolicyCheck onCheckChange={onCheckChange} />} */}
            </div>
            <Popup
                theme="black"
                visible={popupVisible}
                title={t('sec2_popup_title')}
                content={t('sec2_popup_desc')}
                buttonText={t('sec2_popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
            />
        </div>
    );
}
